import { betStore, gameStore, roundStore, userStore } from '../stores';
import { gameConnection } from '../signalR/gameConnection';
import { IBetModel, IHistoryItem, IHistoryTicket, IReBetModel, IUpdateBet } from '../interfaces/bet';
import { notificationService } from './notificationService';
import { RoundStatus } from '../enums/round-status';

class BetService {

  setBetAmount = (amount: number) => {
    const { maxBetAmount, minBetAmount } = gameStore;
    if (amount > maxBetAmount) {
      notificationService.show('NOTIFICATION_REACHED_MAX_AMOUNT', 'warning');
      betStore.setAmount(maxBetAmount);
      return;
    }

    if (amount < minBetAmount) {
      notificationService.show('NOTIFICATION_REACHED_MIN_AMOUNT', 'warning');
      betStore.setAmount(minBetAmount);
      return;
    }

    betStore.setAmount(amount);
  }

  doBet = () => {
    if (roundStore.roundStatus !== RoundStatus.Started) {
      return;
    }

    if (!betStore.selectedNumbers.length) {
      notificationService.show('NOTIFICATION_PLEASE_SELECT_NUMBER', 'warning');
      return;
    }

    console.log(betStore.amount > userStore.balance)
    if (betStore.amount > userStore.balance) {
      notificationService.show('NOTIFICATION_INSUFFICIENT_FUNDS', 'error');
      return;
    }

    gameConnection.doBet({
      roundId: roundStore.roundId,
      amount: betStore.amount,
      numbers: [...betStore.selectedNumbers],
    });
    betStore.clearSelectedNumbers();
  }

  updateBet = () => {
    if (!betStore.selectedNumbers.length) {
      return;
    }

    gameConnection.updateBet({
      id: betStore.betToEdit!.id,
      numbers: [...betStore.selectedNumbers],
    });
    betStore.clearSelectedNumbers();
    betStore.setBetToEdit(null);
  }

  handleBet = (data: IBetModel) => {
    if (data.bet.userId === userStore.id) {
      notificationService.show('NOTIFICATION_YOUR_BET_IS_ACCEPTED');
      userStore.setBalance(data.realBalance || 0);
      betStore.setAllBetsCount(betStore.allBetsCount + 1);
      betStore.unshiftCurrentBet(data.bet);
    } else {
      betStore.pushCurrentBet(data.bet);
    }
  }

  handleReBet = (data: IReBetModel) => {
    if (!data.bets.length)
      return;

    if (data.bets[0].userId === userStore.id) {
      notificationService.show('NOTIFICATION_YOUR_BET_IS_ACCEPTED');
      userStore.setBalance(data.realBalance || 0);
      betStore.setAllBetsCount(betStore.allBetsCount + data.bets.length);
      data.bets.forEach((bet) => {
        if (bet.userId === userStore.id) {
          betStore.unshiftCurrentBet(bet);
        }
      });
    } else {
      data.bets.forEach((bet) => {
        betStore.pushCurrentBet(bet);
      });
    }
  }

  reBet = (ticket: IHistoryTicket) => {
    if (ticket.amount > userStore.balance) {
      notificationService.show('NOTIFICATION_INSUFFICIENT_FUNDS', 'error');
      return;
    }

    gameConnection.doBet({
      roundId: roundStore.roundId,
      amount: ticket.amount,
      numbers: [...ticket.numbers],
    });
  }

  reBetRound = (data: IHistoryItem) => {
    if (data.totalBetAmount > userStore.balance) {
      notificationService.show('NOTIFICATION_INSUFFICIENT_FUNDS', 'error');
      return;
    }

    gameConnection.reBet(data.roundId, roundStore.roundId);
  }

  handleBetUpdate = (data: IUpdateBet) => {
    const bet = betStore.currentBets.find(x => x.id === data.id);
    if (bet) {
      notificationService.show('NOTIFICATION_YOUR_BET_IS_UPDATED');
      bet.numbers = data.numbers;
      betStore.setCurrentBets(betStore.currentBets);
      betStore.clearSelectedNumbers();
    }
  }

  handleBetError = (error: string) => {
    notificationService.show(error, 'error');
  }

  handleReBetError = (error: string) => {
    notificationService.show(error, 'error');
  }

  handleUpdateBetError = (error: string) => {
    notificationService.show(error, 'error');
  }

}

export const betService = new BetService();
